import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="text-center mb-12">
        <span className="inline-block px-3 py-1 rounded-full border border-accent-300 text-accent-600 text-xs font-medium mb-4">
          热门频道
        </span>
        <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
          吃瓜分类导航
        </h2>
        <p className="text-foreground-500 text-sm max-w-2xl mx-auto">
          覆盖91今日吃瓜、今日吃瓜合集、51国产吃瓜在线等核心搜索词，一站式吃瓜体验
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.slug}`}
            className="group block p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-500 transition-all duration-300 cursor-pointer"
            data-product-shop=""
          >
            <div className={`w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full ${cat.color} mb-4 group-hover:bg-white/20 group-hover:text-white transition-colors`}>
              <i className={`${cat.icon} text-xl`}></i>
            </div>
            <h3 className="text-base font-bold font-heading text-foreground-950 group-hover:text-white mb-1.5">
              {cat.name}
            </h3>
            <p className="text-xs text-foreground-500 group-hover:text-white/70 leading-relaxed mb-3 line-clamp-2">
              {cat.description}
            </p>
            <span className="inline-flex items-center gap-1 text-xs font-medium text-accent-600 group-hover:text-white whitespace-nowrap">
              进入频道
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}